import React, { Component } from "react";
//import { connect } from "react-redux";
import { Card } from "material-ui/Card";
import { Flex, Box } from "rebass";
import { translate } from "admin-on-rest";
import TextField from "material-ui/TextField";
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import IconButton from "material-ui/IconButton";
import { connect } from "react-redux";
import compose from "recompose/compose";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
  TableFooter
} from "material-ui/Table";
import IconDelete from "material-ui/svg-icons/action/delete";
import {
  GET_LIST,
  showNotification as showNotificationAction
} from "admin-on-rest";
import { cyan500, pink500 } from "material-ui/styles/colors";
import { ViewTitle, Pagination } from "../../components";
import { HeaderTitle, DivFormContainer } from "../styled";
import { RestClient, RestApiKOLActions } from "../../restClient";
class KolList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      textSearch: "",
      list: [],
      page: 1,
      totalPage: 0,
      perPage: 50,
      openDialog: false,
      user: {}
    };
    // console.log(this.props.match);
    this.getKolList(this.props.match.params, {});
  }
  handleOpen = user => {
    this.setState({ openDialog: true, user: user });
  };

  handleClose = () => {
    this.setState({ openDialog: false });
  };
  handleDelete = () => {
    this.setState({ openDialog: false });
    this.deleteKol();
  };

  getKolList(params, filters) {
    const { perPage, page } = this.state;
    RestClient(GET_LIST, `campaignMarketers/${params.id}`, {
      pagination: { page: page, perPage: perPage },
      sort: { field: "email", order: "ASC" },
      filter: filters
    })
      .then(items => {
        if (items && items.data) {
          this.setState({
            list: items.data,
            totalPage: items.total
          });
        }
      })
      .catch(e => {
        // resolve([]);
      });
  }
  deleteKol() {
    const { user } = this.state;
    const { match } = this.props;
    const paramsId = match.params && match.params.id ? match.params.id : "";
    if (user.id) {
      const values = {
        id: user.id
      };
      RestApiKOLActions(paramsId, values, "DELETE")
        .then(response => response.json())
        .then(items => {
          if (items && items.id) {
            this.getKolList(match.params, {});
            this.props.showNotification("Element Deleted");
          } else {
            this.props.showNotification("Please try again", "warning");
          }
        })
        .catch(e => {
          // console.log(e);
          this.props.showNotification("Please try again", "warning");
        });
    } else {
      this.props.showNotification("Please try again", "warning");
    }
  }

  setPage = page => {
    this.setState({
      page: 2
    });
    this.getKolList(this.props.match.params, {});
  };
  onSearch = (event, value) => {
    this.setState({
      textSearch: value
    });
    setTimeout(this.onResultSearch.bind(this, value), 1000);
  };
  onResultSearch = value => {
    if (value === this.state.textSearch) {
      const filters = { search: value };
      this.getKolList(this.props.match.params, filters);
    }
  };
  render() {
    const { list, totalPage, perPage, page } = this.state;
    const actions = [
      <FlatButton label="Cancel" primary={true} onClick={this.handleClose} />,
      <FlatButton label="Submit" primary={true} onClick={this.handleDelete} />
    ];
    return (
      <div>
        <Card containerStyle={{ minHeight: 318 }}>
          <ViewTitle title={<HeaderTitle {...this.props} />} />
          <DivFormContainer w={[1]}>
            <Flex w={[1]} justify={["flex-end"]} p={[1]}>
              <TextField
                hintText="Search..."
                onChange={this.onSearch.bind(this)}
              />
            </Flex>
            <Box w={[1]} p={[1]}>
              <Table selectable={false}>
                <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                  <TableRow style={styles.rowHeader}>
                    <TableHeaderColumn style={styles.titleHeader}>
                      Email
                    </TableHeaderColumn>
                    {/* <TableHeaderColumn style={styles.titleHeader}>
                      Name
                    </TableHeaderColumn> */}
                    <TableHeaderColumn style={styles.titleHeader}>
                      Nickname
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      style={{ width: 60, paddingLeft: 10, paddingRight: 10 }}
                    />
                  </TableRow>
                </TableHeader>
                <TableBody displayRowCheckbox={false}>
                  {list.map((row, index) => (
                    <TableRow key={index}>
                      <TableRowColumn>{row.email}</TableRowColumn>
                      {/* <TableRowColumn>
                        {row.first_name} {row.last_name}
                      </TableRowColumn> */}
                      <TableRowColumn>{row.nickname}</TableRowColumn>
                      <TableRowColumn
                        style={{
                          textAlign: "right",
                          width: 60,
                          paddingLeft: 10,
                          paddingRight: 10
                        }}
                      >
                        <IconButton onClick={this.handleOpen.bind(this, row)}>
                          <IconDelete color={pink500} />
                        </IconButton>
                      </TableRowColumn>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter adjustForCheckbox={false}>
                  <TableRow>
                    <TableRowColumn colSpan="5" style={styles.rowFooter}>
                      <Pagination
                        page={page}
                        total={totalPage}
                        perPage={perPage}
                        setPage={this.setPage.bind(this)}
                      />
                    </TableRowColumn>
                  </TableRow>
                </TableFooter>
              </Table>
            </Box>
          </DivFormContainer>
        </Card>
        <Dialog
          title="Delete User"
          actions={actions}
          modal={true}
          open={this.state.openDialog}
        >
          Are you sure want to delete{" "}
          <span style={{ color: pink500 }}>{this.state.user.email}</span> ?
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const enhance = compose(
  connect(
    mapStateToProps,
    { showNotification: showNotificationAction }
  ),
  translate
);

export default enhance(KolList);

// export default translate(KolList);

const styles = {
  rowHeader: {
    backgroundColor: cyan500
  },
  rowFooter: {
    // backgroundColor:   grey100,
    padding: "0px",
    width: "100%"
  },
  titleHeader: {
    color: "#FFFFFF",
    fontSize: "14px"
  }
};



// WEBPACK FOOTER //
// ./src/campaigns/kol/KolList.js